import {putResolve, takeLeading, select, throttle, takeEvery, put} from 'redux-saga/effects';
import {CUSTOMER, CUSTOMER_FAILURE, CUSTOMER_REQUEST, CUSTOMER_SUCCESS} from 'new-constants/api.constants';
import {getCurrentAuthSelector, getCurrentRestaurantIdSelector} from '../selectors';
import {getCustomer} from 'new-actions/api.actions.ts';
import {cauthClearCustomerData} from "../actions/app-state.actions";

function isCustomerNotFetched(customer) {
	if (!(customer.isFetchedOnce && customer.currentCustomer)) {
		return true;
	}

	return false;
}

function isCustomerOutdated(customer, currentRestaurantId, currentAuth) {
	if (customer.currentCustomer && currentAuth && customer.udid !== currentAuth.udid) {
		return true;
	}

	if (
		currentRestaurantId &&
		customer.currentCustomer &&
		(!customer.currentCustomer.restaurant || customer.currentCustomer.restaurant.restaurantId !== currentRestaurantId)
	) {
		return true;
	}

	return false;
}

function* getCustomerIfNecessary() {
	const state = yield select();
	const {customer, restaurantList, appState, connectivity, auth, fetchProgress} = state;

	if (fetchProgress[CUSTOMER]) {
		return;
	}

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);
	const currentAuth = getCurrentAuthSelector(state);

	if (
		(isCustomerNotFetched(customer) || isCustomerOutdated(customer, currentRestaurantId, currentAuth)) &&
		connectivity.isOnline &&
		getCurrentAuthSelector(state) &&
		restaurantList.isFetchedOnce
	) {
		yield putResolve(getCustomer(currentRestaurantId));
	}
}

function* clearCustomerData(action) {
		if (action.meta.cauth === false) {
			const state = yield select();
			const {restaurantList} = state;
			yield put(cauthClearCustomerData(action.meta.appId, restaurantList.cache[action.meta.appId].restaurants.map(restaurant => restaurant.restaurantId)));
		}
}

export const customerUpdaterSaga = function* customerUpdaterSaga() {
	yield throttle(
		2500,
		[action => ![CUSTOMER_REQUEST, CUSTOMER_SUCCESS, CUSTOMER_FAILURE].includes(action.type)],
		getCustomerIfNecessary
	);
	
	yield takeEvery([CUSTOMER_FAILURE], clearCustomerData);
};
